/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { useCallback, useContext, useEffect, useState } from "react";

import { Snackbar } from "@origin-digital/ods-core";

const ToastContext = React.createContext(null as any);

export const useToastContext = () => useContext(ToastContext);

export const ToastContextProvider = ({ children }: { children: any }) => {
  const [toasts, setToasts] = useState<any>([]);

  useEffect(() => {
    if (toasts.length == 0) return;

    const timer = setTimeout(() => setToasts(toasts.slice(1)), 3000);

    return () => clearTimeout(timer);
  }, [toasts]);

  const addToast = useCallback(
    (toast: any) => {
      setToasts([...toasts, toast]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setToasts]
  );

  return (
    <ToastContext.Provider value={addToast}>
      {children}
      <div>
        {toasts.map((toast: any) => (
          <Snackbar key={toast} open={true}>
            {toast}
          </Snackbar>
        ))}
      </div>
    </ToastContext.Provider>
  );
};
